import {
  Box,
  Typography,
  Alert,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppInfo } from '../hooks';

export const AppInfoComponent = () => {
  const { t } = useTranslation();
  const { appInfo, loading, error } = useAppInfo();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error || !appInfo) {
    return (
      <Box sx={{ mt: 3, mb: 2 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography variant='h6' sx={{ mb: 2 }}>
          {t('app_info.title')}
        </Typography>
        <Alert severity='info' sx={{ mt: 2 }}>
          {error || t('app_info.error')}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Divider sx={{ mb: 2 }} />
      <Typography variant='h6' sx={{ mb: 2 }}>
        {t('app_info.title')}
      </Typography>

      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <List disablePadding>
          <ListItem>
            <ListItemText
              primary={t('app_info.application_name')}
              secondary={appInfo.applicationName}
            />
          </ListItem>
          <Divider />

          {/* <ListItem>
            <ListItemText
              primary={t('app_info.application_version')}
              secondary={appInfo.applicationVersion}
            />
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText
              primary={t('app_info.build_version')}
              secondary={appInfo.buildVersion}
            />
          </ListItem>
          <Divider /> */}

          <ListItem>
            <ListItemText
              primary={t('app_info.database_catalog_name')}
              secondary={appInfo.databaseCatalogName}
            />
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText
              primary={t('app_info.current_user_name')}
              secondary={appInfo.currentUserName}
            />
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText
              primary={t('app_info.environment')}
              secondary={
                <Box
                  component='span'
                  sx={{
                    py: 0.5,
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 'medium',
                    textTransform: 'uppercase',
                  }}
                >
                  {appInfo.environment}
                </Box>
              }
            />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};
